import ThemIcon from './component'

export default ThemIcon

